import React from 'react';
import cn from 'classnames';
import MinusIcon from '@components/icons/minus-icon';
import PlusIcon from '@components/icons/plus-icon';
import mergeCn from '@utils/merge-cn';
interface Props {
  handleItemQuantity: (type: 'add' | 'rm') => void;
  itemQuantity: number;
  maxQuantity?: number;
  className?: string;
}

const QuantityButton: React.FC<Props> = ({
  handleItemQuantity,
  itemQuantity,
  maxQuantity,
  className,
}) => {
  return (
    <div
      className={mergeCn(
        `flex align-middle text-base lg:text-lg items-center justify-between rounded space-x-2 border-brown border-1 min-w-[120px]`,
        className,
      )}
    >
      <button
        className="pl-3 py-4 cursor-pointer text-blackText hover:text-black disabled:opacity-50"
        onClick={() => handleItemQuantity('rm')}
        disabled={itemQuantity === 1}
      >
        <MinusIcon width={10} height={10} />
      </button>
      <span>{itemQuantity}</span>
      <button
        className="pr-3 py-1 text-blackText hover:text-black cursor-pointer disabled:opacity-50"
        onClick={() => {
          handleItemQuantity('add');
        }}
        disabled={maxQuantity !== undefined && itemQuantity >= maxQuantity}
      >
        <PlusIcon width={10} height={10} />
      </button>
    </div>
  );
};

export default QuantityButton;
